module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('date-from-to', {
    attrs: {
      "label": "Activation Dates",
      "value": {
        from: _vm.value.flightStartDate,
        to: _vm.value.flightEndDate
      },
      "fromNotBeforeDate": _vm.startingFromDate,
      "disableFrom": _vm.startDateDisable,
      "disableTo": _vm.endDateDisable,
      "startToDateFromToday": "",
      "optionSetting": 4
    },
    on: {
      "input": function (val) { return _vm.modifyDates(val); }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c039654"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/components/FlightDates.vue
// module id = 1953
// module chunks = 0